'use strict';

import { Entity } from '../Entity';

export class UserProfilePic extends Entity {
  protected profilePicId;

  protected user;

  protected profilePicName;

  protected profilePicUrl;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    // this.profilePicId = data.profilePicId;

    //this.user = data.user;

    this.profilePicName = data.profilePicName;
    this.profilePicUrl = data.profilePicUrl;
  }

  public getProfilePicId() {
    return this.profilePicId;
  }

  public setProfilePicId(profilePicId) {
    this.profilePicId = profilePicId;

    return this;
  }

  public getUser() {
    return this.user;
  }

  public setUser(user) {
    this.user = user;

    return this;
  }

  public getProfilePicName() {
    return this.profilePicName;
  }

  public setProfilePicName(profilePicName) {
    this.profilePicName = profilePicName;

    return this;
  }

  public getProfilePicUrl() {
    return this.profilePicUrl;
  }
}
